import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    available: 'Available on iOS and Android',
    download: 'Download the app',
    score: '4.8/5 average rating',
    sendAgain: 'Send me the link again',
    sendingAgain: `Sending can take few seconds...`,
    sentTo: 'Sent to',
    thankYou: 'Thank you! We sent you a text\nmessage to download the app',
  },
  fr: {
    available: 'Disponible sur iOS et Android',
    download: 'Télécharger l’application',
    score: 'Notée 4,8/5 en moyenne',
    sendAgain: 'Envoyer le lien à nouveau',
    sendingAgain: 'L’envoi peut prendre quelques secondes...',
    sentTo: 'Envoyé au',
    thankYou:
      'Merci\u00A0! Nous vous avons envoyé un message pour télécharger l’application',
  },
} as const);
